import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Sign in again.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background text-foreground">
      <div className="w-full max-w-md">
        <div className="eyebrow text-muted-foreground mb-2">Recovery</div>
        <h1 className="display text-3xl font-semibold tracking-tighter mb-6">Set a new password</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <div>
            <Label className="eyebrow text-muted-foreground">New password</Label>
            <Input data-testid="reset-password-input" value={password} onChange={e => setPassword(e.target.value)} type="password" className="mt-1.5 h-11" />
          </div>
          <Button data-testid="reset-submit-btn" type="submit" className="w-full h-11">Reset password</Button>
        </form>
        <div className="mt-6 text-sm"><Link to="/login" className="text-primary hover:underline">← Back to sign in</Link></div>
      </div>
    </div>
  );
}
